import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { Search, BookOpen, MessageCircle, Video, FileText, ChevronDown } from "lucide-react";

const HelpCenterPage = () => {
  const categories = [
    {
      icon: BookOpen,
      title: "Başlangıç Rehberi",
      desc: "Verasist'e yeni misiniz? Platformu adım adım tanıyın.",
      articles: ["Hesap oluşturma ve kurulum", "İlk sesli ajanınızı oluşturma", "Dashboard kullanım kılavuzu", "Temel kavramlar sözlüğü"],
    },
    {
      icon: MessageCircle,
      title: "Sesli Ajan Yönetimi",
      desc: "Sesli ajanlarınızı yapılandırma ve optimize etme.",
      articles: ["Ajan kişiliği ve ses tonu ayarları", "Senaryo tasarımı ve dallanma", "Dil ve aksan seçenekleri", "Performans metrikleri ve raporlama"],
    },
    {
      icon: Video,
      title: "Entegrasyonlar",
      desc: "CRM, telefon ve diğer sistemlerle entegrasyon.",
      articles: ["NetGSM / Verimor entegrasyonu", "Microsoft Dynamics 365 bağlantısı", "HubSpot ve Zendesk kurulumu", "Webhook ve API kullanımı"],
    },
    {
      icon: FileText,
      title: "Sık Sorulan Sorular",
      desc: "En çok merak edilen sorular ve cevapları.",
      articles: ["Fiyatlandırma nasıl çalışır?", "Veri güvenliği ve KVKK uyumu", "Görüşme kalitesi ve gecikme süreleri", "İnsan temsilciye aktarım nasıl yapılır?"],
    },
  ];

  const hero = (
    <PageHero
      eyebrow="Yardım Merkezi"
      title="Size nasıl yardımcı olabiliriz?"
      subtitle="Verasist hakkında merak ettiğiniz her şey için rehberler, dokümanlar ve SSS."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/pages/help-desk.jpg" alt="Yardım masası" height="340px" />
      {/* Search */}
      <SectionReveal>
        <section className="pb-8 px-6">
          <div className="max-w-xl mx-auto">
            <div className="relative">
              <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2" style={{ color: "var(--muted)" }} />
              <input
                type="text"
                placeholder="Yardım merkezinde ara..."
                className="w-full pl-11 pr-4 py-3 rounded-xl text-[14px] transition-colors duration-200 outline-none"
                style={{ background: "var(--card-bg)", border: "1px solid var(--border)", color: "var(--fg)" }}
              />
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-10 px-6">
          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-2 gap-5">
              {categories.map((cat) => (
                <div
                  key={cat.title}
                  className="p-6 rounded-2xl transition-colors duration-200"
                  style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                      <cat.icon size={20} />
                    </div>
                    <div>
                      <h3 className="text-[16px] font-semibold" style={{ color: "var(--fg)" }}>{cat.title}</h3>
                      <p className="text-[12.5px]" style={{ color: "var(--fg)", opacity: 0.7 }}>{cat.desc}</p>
                    </div>
                  </div>
                  <ul className="space-y-2">
                    {cat.articles.map((a) => (
                      <li key={a}>
                        <a
                          href="#"
                          className="text-[13.5px] transition-colors duration-200 inline-flex items-center gap-1.5"
                          style={{ color: "var(--fg)", opacity: 0.82 }}
                          onMouseEnter={(e) => (e.currentTarget.style.color = "var(--brand-cyan)")}
                          onMouseLeave={(e) => (e.currentTarget.style.color = "var(--fg)")}
                        >
                          <ChevronDown size={12} className="-rotate-90" style={{ opacity: 0.5 }} />
                          {a}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-[22px] font-bold mb-3" style={{ color: "var(--fg)" }}>Aradığınızı bulamadınız mı?</h2>
            <p className="text-[14px] mb-6" style={{ color: "var(--fg)", opacity: 0.82 }}>
              Destek ekibimiz size yardımcı olmak için burada. Bize doğrudan yazın, en kısa sürede dönüş yapalım.
            </p>
            <a
              href="mailto:destek@verasist.ai"
              className="inline-block px-8 py-3 rounded-full font-semibold text-[14px] transition-all duration-200"
              style={{ background: "var(--brand-navy)", color: "#fff" }}
            >
              Destek Ekibine Yazın
            </a>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default HelpCenterPage;
